import React from 'react';
import { useTranslation } from 'react-i18next';
import { Formik } from 'formik';
import { ClipLoader } from 'react-spinners';
import InputProfile from './inputProfile';

const IntegrationCard = ({ integration, onLink, onUnlink }) => {
    const { t } = useTranslation();

    return (
      <div className="relative border rounded-lg p-4 shadow-md bg-white">
        <span className="absolute top-2 right-2 text-gray_local-400 text-xs">{integration.importance}</span>
        
        <h3 className="text-lg font-semibold mb-2">{integration.name}</h3>
        <p className="text-sm mb-2">{integration.text}</p>

        {integration.requiresFunding && (
          <div className="mb-3 p-3 bg-red-100 border border-red-400 text-red-700 text-sm rounded">
            {t('insufficient-funds', 'Votre compte n’a plus de fonds. Veuillez recharger pour continuer.')}
          </div>
        )}

        <Formik
          initialValues={integration.apiKey ? { apiKey: integration.apiKey } : integration.initialValues}
          validationSchema={integration.validationSchema}
          enableReinitialize={true}
          onSubmit={(values, actions) => onLink(integration, values, actions)}
        >
          {(props) => (
            <form onSubmit={props.handleSubmit} className="space-y-2">
              <InputProfile
                formikProps={props}
                type="text"
                text={t('api-key', 'Clé API')}
                name="apiKey"
                placeholder={integration.placeholder}
                disabled={!!integration.apiKey}
                onUnlink={onUnlink}
                unlinkLoading={integration.unlinkLoading}
                integration={integration}
              />

              <div className="flex justify-end items-center">
                <button
                  type="submit"
                  className="px-5 py-2 bg-blue-400 text-white rounded hover:bg-blue-500 disabled:bg-gray-400"
                  disabled={integration.linkLoading || integration.apiKey || integration.requiresFunding}
                >
                  {integration.linkLoading ? <ClipLoader size={20} color="white" /> : t('connect', 'Connecter')}
                </button>
              </div>
            </form>
          )}
        </Formik>
      </div>
    );
};

export default IntegrationCard;